import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";
import ApproverViewRequest from "../pages/ApproverViewRequest";

const ApproverRouter = () => {
    
    return (
        <Routes>
            <Route element={<PersistLogin />}>
                <Route element={<RequireAuth allowedRoles={["200", "300"]} />}>
                    <Route path="/view-request" element={<ApproverViewRequest />} />
                    <Route path="*" element={<NotFound404 />} />
                </Route>
            </Route>
        </Routes>
    )
}

export default ApproverRouter;